<!--折扣变更-->
<template>
<div>
    <br />
    <el-tabs type="border-card">
        <el-tab-pane label="导入折扣">
            <el-form :model="editForm" ref="editForm" :rules="editFormRules" v-loading="editFormLoading">
                <el-form-item label="选择折扣：">
                    <el-select v-model="editForm.discountId" placeholder="请选择对应折扣" filterable clearable>
                        <el-option v-for="item in options_discount" :label="item.name" :value="item.id" v-bind:key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="cardNumArrStr">
                                <el-input type="textarea" :rows="20" placeholder="请粘贴要导入折扣的卡号号码列表(每一条一行)，最多2万行" v-model="editForm.cardNumArrStr" class="textexport">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="expireTimeArrStr">
                                <el-input type="textarea" :rows="20" placeholder="请粘贴要导入折扣的生效时间列表(每一条一行)，最多2万行" v-model="editForm.expireTimeArrStr" class="textexport">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="" v-show="editForm.tip.show">
                    <el-alert style="height:10%;opacity:0.8;" :title="editForm.tip.title" type="info" :closable="false" show-icon>
                    </el-alert>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click.native="editFormAction()">提交</el-button>
                    <el-button @click="resetForm('editForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="删除折扣">
            <el-form :model="delForm" ref="delForm" :rules="delFormRules" v-loading="delFormLoading">
                <el-form-item label="选择折扣：">
                    <el-select v-model="delForm.discountId" placeholder="请选择对应折扣" filterable clearable>
                        <el-option v-for="item in options_discount" :label="item.name" :value="item.id" v-bind:key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="cardNumArrStr">
                    <el-input type="textarea" :rows="20" placeholder="请粘贴要删除折扣的卡号号码列表(每一条一行)，最多2万行" v-model="delForm.cardNumArrStr" class="textexport">
                    </el-input>
                </el-form-item>
                <el-form-item label="" v-show="delForm.tip.show">
                    <el-alert style="height:10%;opacity:0.8;" :title="delForm.tip.title" type="info" :closable="false" show-icon>
                    </el-alert>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="delFormAction()">提交</el-button>
                    <el-button @click="resetForm('delForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import {
    getAllDiscount,
    editCardDiscount,
    delCardDiscount
} from '../../api/api'
export default {
    data() {
        return {
            options_discount: [],
            editFormLoading: false,
            editForm: {
                discountId: "",
                cardNumArrStr: "",
                expireTimeArrStr: "",
                tip: {
                    show: false,
                    title: "卡号数量与折扣到期数量不一致，请检查！"
                }
            },
            editFormRules: {
                discountId: [{
                    required: true,
                    message: '导入折扣不能为空',
                    trigger: 'blur'
                }],
                cardNumArrStr: [{
                        validator: this.validEditCardNumArr,
                        trigger: 'change'
                    },
                    {
                        required: true,
                        message: '卡号列表不能为空',
                        trigger: 'blur'
                    }
                ],
                expireTimeArrStr: [{
                        validator: this.expireTimeArrStr,
                        trigger: 'change'
                    },
                    {
                        required: true,
                        message: '过期列表不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            delFormLoading: false,
            delForm: {
                discountId: "",
                cardNumArrStr: "",
                tip: {
                    show: false,
                    title: ""
                }
            },
            delFormRules: {
                cardNumArrStr: [{
                        validator: this.validCardNumArr,
                        trigger: 'change'
                    },
                    {
                        required: true,
                        message: '卡号列表不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            exportLoading: false
        }
    },
    mounted() {
        let para = {};
        getAllDiscount(para).then((res) => {
            this.editLoading = false;
            this.options_discount = res.data;
        });
    },
    methods: {
        validEditCardNumArr(rule, value, callback) {
            if (typeof value == "undefined" || value == null || value == "") {
                this.editForm.tip.show = false;
                this.editForm.tip.title = "";
                callback();
                return;
            }
            var arr = value.split("\n");
            var count = 0;
            for (var i = 0; i < arr.length; i++) {
                if (typeof arr[i] == "undefined" || arr[i] == null || arr[i] == "") {
                    continue;
                }
                count++;
            }
            this.editForm.tip.title = "您将导入卡数量：" + count;
            this.editForm.tip.show = true;
            callback();
        },
        expireTimeArrStr(rule, value, callback) {
            if (typeof value == "undefined" || value == null || value == "") {
                callback();
                return;
            }
            var arr = value.split("\n");
            var count = 0;
            for (var i = 0; i < arr.length; i++) {
                if (typeof arr[i] == "undefined" || arr[i] == null || arr[i] == "") {
                    continue;
                }
                count++;
            }
            var cardArr = this.editForm.cardNumArrStr.split("\n");
            var cardCount = 0;
            for (var i = 0; i < cardArr.length; i++) {
                if (typeof cardArr[i] == "undefined" || cardArr[i] == null || cardArr[i] == "") {
                    continue;
                }
                cardCount++;
            }
            if (cardCount != count) {
                this.editForm.tip.title = "卡号数量与折扣到期数量不一致，请检查！导入卡数量：【" + cardCount + "】,导入过期数量：【" + count + "】";
                this.editForm.tip.show = true;
            }
            callback();
        },
        validCardNumArr(rule, value, callback) {
            if (typeof value == "undefined" || value == null || value == "") {
                this.delForm.tip.show = false;
                this.delForm.tip.title = "";
                callback();
                return;
            }
            var arr = value.split("\n");
            var count = 0;
            for (var i = 0; i < arr.length; i++) {
                if (typeof arr[i] == "undefined" || arr[i] == null || arr[i] == "") {
                    continue;
                }
                count++;
            }
            this.delForm.tip.title = "您将删除卡数量：" + count;
            this.delForm.tip.show = true;
            callback();
        },
        resetForm(formName) {
            this.$refs["editForm"].resetFields();
            this.$refs["delForm"].resetFields();
            this.editForm.tip.show = false;
            this.editForm.tip.title = "";
            this.editForm.discountId = "";
            this.editForm.cardNumArrStr = "";
            this.editForm.expireTimeArrStr = "";
            this.delForm.tip.show = false;
            this.delForm.tip.title = "";
            this.delForm.discountId = "";
            this.delForm.cardNumArrStr = "";
        },
        editFormAction() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    if (typeof this.editForm.discountId == "undefined" || this.editForm.discountId == null || this.editForm.discountId == "") {
                        this.$message({
                            message: "请选择要导入的折扣",
                            type: 'warning',
                        });
                        return;
                    }
                    var param = this.editForm;
                    this.editFormLoading = true;
                    editCardDiscount(param).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "导入折扣成功",
                                type: 'success',
                            });
                            this.editForm.tip.show = false;
                            this.editForm.tip.title = "";
                            this.editForm.discountId = "";
                            this.editForm.cardNumArrStr = "";
                            this.editForm.expireTimeArrStr = "";
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                        this.editFormLoading = false;
                    });
                }
            });
        },
        delFormAction() {
            this.$refs["delForm"].validate((valid) => {
                if (valid) {
                    var param = this.delForm;
                    this.delFormLoading = true;
                    delCardDiscount(param).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "删除折扣成功",
                                type: 'success',
                            });
                            this.delForm.tip.show = false;
                            this.delForm.tip.title = "";
                            this.delForm.discountId = "";
                            this.delForm.cardNumArrStr = "";
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                        this.delFormLoading = false;
                    });
                }
            });
        }
    }

}
</script>  

<style>
.textexport {
    margin-top: 10px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// discountChange.vue?1dd32ae6